const propertyFiltersToggle = document.getElementById('property-filters-toggle');
const propertyFilterForm = document.getElementById('views-exposed-form-property-list-page-3');

function runPropertyFilterToggle() {
  propertyFiltersToggle.addEventListener('click', function handleClick() {
    const button = this;

    if (propertyFilterForm.hidden === true) {
      propertyFilterForm.hidden = false;
      button.setAttribute('aria-expanded', 'true');
    } else {
      propertyFilterForm.hidden = true;
      button.setAttribute('aria-expanded', 'false');
    }
  });
}

function resetPropertyFilterToggle() {
  if (window.innerWidth >= 880) {
    // Reset the elements if window size is equal or greater than 880px
    propertyFiltersToggle.setAttribute('aria-expanded', 'false');
    propertyFilterForm.hidden = false;
  } else {
    // propertyFiltersToggle.setAttribute('aria-expanded', 'true');
  }
}

if (propertyFiltersToggle) {
  if (window.innerWidth < 880) {
    // Set property filter form to hidden on pageload
    propertyFilterForm.hidden = true;

    // Run property filter toggle function if clicked
    runPropertyFilterToggle();
  }

  // Adjust filter display on window resize
  window.addEventListener('resize', resetPropertyFilterToggle);
}
